import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { fetchJSON } from '@haina/utils-request'
import { isEmpty, isNotEmpty } from '@haina/utils-commons'
import { API_HOST } from '@/config'
import { usingStorage } from '@/utils/usingStorage';

export const PERM_MERGE_CONVERSATION = 'merge-conversation'
export const PERM_ASSIGN_NEW_CONVERSATION = 'assign-new-conversation'
export const PERM_USE_EMAL = 'use-email'
export const PERM_USE_WHATSAPP = 'use-whatsapp'
export const PERM_IMPORT_EMAIL = 'import-email'

const WAI_SERVER_KEY = 'G-STR:WAI_SERVER'

const useAuthStore = create(devtools((set, get) => ({
  loginUser: {
    userId: -1,
    userIdStr: '-1',
    username: '',
    avatarUrl: '',
    mobile: '',
    email: '',
    openId: '',
    accountList: [],
    emailList: [],
    whatsAppBusiness: '',
    accountName: '',
  },

  loginStatus: 0,

  isPermitted: (perm) => {
    const { waiServer } = usingStorage(WAI_SERVER_KEY)
    const { loginUser } = get()

    if (perm === PERM_USE_WHATSAPP) {
      return isNotEmpty(waiServer) // ['370', '143', '495', '404', '383', '227'].includes(loginUser.userId)
    }

    if (perm === PERM_USE_EMAL) {
      return true//['501', '466', '599', '495', '143', '370', '639', '513', '654', '404', '383', '227'].includes(loginUser.userId)
    }

    // 导入邮件消息，需要配置才能使用
    if (perm === PERM_IMPORT_EMAIL && window.localStorage.getItem('PERM_IMPORT_EMAIL')) {
      return true
    }

    if (perm === PERM_MERGE_CONVERSATION) {
      return ['404', '383', '227'].includes(loginUser.userId)
    }

    if (perm === PERM_ASSIGN_NEW_CONVERSATION) {
      return ['79', '383', '404', '227'].includes(loginUser.userId)
    }

    // 以上是 Hardcode 判断
    // 动态权限列表参考海外供应商平台实现
  },

  login: async (authCode) => {
    const { setStorage } = usingStorage()
    const { saveUserSession, setLoginStatus } = get()

    setLoginStatus(200)

    const json = await fetchJSON(
      'https://p9axztuwd7x8a7.mycht.cn/dingtalk/dingtalkwork/WhatsAppAuth',
      { authCode },
    )

    if (json.errcode === 0 && isNotEmpty(json.result.opisn)) {
      const waiServer = json.result.whatsappinfo.length > 0 ? json.result.whatsappinfo[0].wai_server : ''
      setStorage(WAI_SERVER_KEY, waiServer)
      set(() => ({
        loginUser: {
          userId: json.result.opisn,
          userIdStr: json.result?.accountlist
            .map((acc) => {
              return acc.OPI_SN
            })
            .join(','),
          emailList: json.result?.emaillist.map(item => {
            return {
              opi_sn: item.opi_sn,
              mat_sn: item.mat_sn,
              email: item.email,
              default: item.Isdefaultemail == 1,
              backup: item.Isbakemail == 1,
            }
          }),
          whatsAppBusiness: json.result.whatsappinfo.length > 0 ? json.result.whatsappinfo[0].whatsapp_waba : '',
          whatsAppNo: json.result.whatsappinfo.length > 0 ? json.result.whatsappinfo[0].whatsapp_wa : '',
          accountName: json.result.opicode,
          username: json.result.nick,
          avatarUrl: json.result.avatarUrl,
          mobile: '+' + json.result.stateCode + '-' + json.result.mobile,
          email: json.result.email,
          openId: json.result.openId,
          accountList: json.result.accountlist,
        },
      }))
      saveUserSession()
      setLoginStatus(302)
    } else {
      setLoginStatus(403)
    }
  },

  parseLoginJson: (json) => {
    const { setStorage } = usingStorage()
    if (json.errcode === 0 && isNotEmpty(json.result.opisn)) {
      const waiServer = json.result.whatsappinfo.length > 0 ? json.result.whatsappinfo[0].wai_server : ''
      setStorage(WAI_SERVER_KEY, waiServer)

      const parsedUser = {
        userId: json.result.opisn,
        userIdStr: json.result?.accountlist
          .map((acc) => {
            return acc.OPI_SN
          })
          .join(','),
        emailList: json.result?.emaillist.map(item => {
          return {
            opi_sn: item.opi_sn,
            mat_sn: item.mat_sn,
            email: item.email,
            default: item.Isdefaultemail == 1,
            backup: item.Isbakemail == 1,
          }
        }),
        whatsAppBusiness: json.result.whatsappinfo.length > 0 ? json.result.whatsappinfo[0].whatsapp_waba : '',
        whatsAppNo: json.result.whatsappinfo.length > 0 ? json.result.whatsappinfo[0].whatsapp_wa : '',
        accountName: json.result.opicode,
        username: json.result.nick,
        avatarUrl: json.result.avatarUrl,
        mobile: '+' + json.result.stateCode + '-' + json.result.mobile,
        email: json.result.email,
        openId: json.result.openId,
        accountList: json.result.accountlist,
      }

      return parsedUser
    } else { return null }
  },
  // 钉钉免登后获取用户信息
  loginByJSAuth: async (authCode) => {
    const { saveUserSession, setLoginStatus, parseLoginJson } = get()

    setLoginStatus(200)

    const json = await fetchJSON(
      'https://p9axztuwd7x8a7.mycht.cn/dingtalk/dingtalkwork/Getusers_auth_wa',
      { code: authCode },
    )
    const parsedUser = parseLoginJson(json)

    if (parsedUser) {
      set(() => ({
        loginUser: parsedUser,
      }))
      saveUserSession()
      setLoginStatus(302)
    } else {
      setLoginStatus(403)
    }


  },

  getPrimaryEmail: () => {
    const { loginUser } = get()

    const defaultList = loginUser.emailList.filter(email => {
      return email.default
    })

    if (defaultList.length > 0) {
      return defaultList[0].email
    } else {
      const backupList = loginUser.emailList.filter(email => {
        return email.backup
      })

      if (backupList.length > 0) {
        return backupList[0].email
      } else if (loginUser.emailList.length > 0) {
        return loginUser.emailList[0].email
      }
    }
  },

  setLoginStatus: (code) => {
    set(() => ({
      loginStatus: code,
    }))
  },

  logout: () => {
    window.sessionStorage.clear()
    set(() => ({
      loginStatus: 0,
      loginUser: {
        userId: -1,
        userIdStr: '-1',
        username: '',
        avatarUrl: '',
        mobile: '',
        email: '',
        openId: '',
        accountList: [],
        emailList: [],
        whatsAppBusiness: '',
        accountName: '',
      },
    }))
  },

  loadUserSession: () => {
    let sessionData = window.sessionStorage.getItem('GLOBAL_SALES_LOGIN_USER')

    if (import.meta.env.DEV && isEmpty(sessionData)) {
      sessionData = window.localStorage.getItem('GLOBAL_SALES_LOGIN_USER')
    }

    if (sessionData !== null) {
      const sesstionObj = JSON.parse(sessionData)
      set(() => ({
        loginUser: sesstionObj,
      }))
    }
  },

  saveUserSession: () => {
    const { loginUser } = get()
    window.sessionStorage.setItem(
      'GLOBAL_SALES_LOGIN_USER',
      JSON.stringify(loginUser),
    )
  },

  setWhatsAppProfile: async (userId, whatsAppBusiness, whatsAppNo) => {
    const { loginUser, saveUserSession } = get()
    const postWABAUrl = `${API_HOST}/v2/set_whatsapp_info`

    const params = {opi_sn: userId, whatsapp_waba: whatsAppBusiness, whatsapp_wa: whatsAppNo.replace(/\D/g, '')};

    return fetchJSON(postWABAUrl, params)
      .then(json => {
        if (json.errcode === 0) {
          set(() => ({
            loginUser: {
              ...loginUser,
              whatsAppNo: whatsAppNo,
              whatsAppBusiness: whatsAppBusiness,
            }
          }))
          saveUserSession()
        } else {
          throw new Error(json?.errmsg + ': ' + json.errcode)
        }
      })
  },
}), { name: 'authStore' }))

export default useAuthStore
